var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4375 3.28125H16.4062C17.1311 3.28125 17.7188 3.86888 17.7188 4.59375V18.375C17.7188 19.0999 17.1311 19.6875 16.4062 19.6875H4.59375C3.86888 19.6875 3.28125 19.0999 3.28125 18.375V4.59375C3.28125 3.86888 3.86888 3.28125 4.59375 3.28125H6.5625V2.625C6.5625 1.90013 7.15013 1.3125 7.875 1.3125H13.125C13.8499 1.3125 14.4375 1.90013 14.4375 2.625V3.28125ZM13.125 2.625H7.875V5.25H13.125V2.625ZM16.4062 18.375H4.59375V4.59375H6.5625V6.5625H14.4375V4.59375H16.4062V18.375ZM6.5625 9.1875H7.875V15.75H6.5625V9.1875ZM14.4375 11.8125H13.125V15.75H14.4375V11.8125ZM11.1562 13.125H9.84375V15.75H11.1562V13.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.2567b8ac6c267a30a1acc6995faf3f38.svg";
export { ForwardRef as ReactComponent };